import React from 'react';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
import { useLazyLoading } from '../../../../LazyLoadingImage/useLazyLoading';
const Img = (props)=>{
    const { file, deviation, imgStyles } = props;
    const { enableLazyLoading, supportsNativeLazy } = useLazyLoading(true);
    const isLazyLoaded = enableLazyLoading && supportsNativeLazy;
    return /*#__PURE__*/ React.createElement("img", {
        loading: isLazyLoaded ? 'lazy' : undefined,
        src: cleanLinkSrc(file.src),
        srcSet: file.srcSet,
        alt: deviation.title,
        style: imgStyles
    });
};
Img.displayName = 'Img';
export default Img;
